import { useTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import { TransactionDTO, TransactionRef } from "../../../../models/transactions";

import { Container, RemoveButton, TransactionInfo } from "./styles";
import { intlFormatDateShort } from "../../../../utils/time-utils";
import { CustomDate } from "../../../../models/custom-date/custom-date";

interface Props {
  transaction: TransactionDTO | TransactionRef | null;
  handleRemoveTransaction?: () => void;
}

const DocumentTransaction = ({ transaction, handleRemoveTransaction }: Props) => {
  const { t } = useTranslation();

  return (
    <Container>
      <TransactionInfo>
        {`${t("components.upload_document.document_transaction.transaction")}: ${transaction?.type?.name}, ${
          transaction ? intlFormatDateShort(CustomDate.ToDate(transaction.transactionDate) as Date) : ""
        } ${t(`components.upload_document.document_transaction.amount`)}:
          ${transaction?.amount} ${transaction?.currency?.code}`}
      </TransactionInfo>
      {handleRemoveTransaction && (
        <RemoveButton onClick={handleRemoveTransaction}>
          <FontAwesomeIcon icon={faTimes} />
        </RemoveButton>
      )}
    </Container>
  );
};

export default DocumentTransaction;
